import { Translate, TranslatePlural } from '@change-corgi/core/react/i18n';
import { Button } from '@change-corgi/design-system-legacy/components/actions';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconNotificationsNone } from '@change-corgi/design-system-legacy/icons';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

import { useDashboardReskinExperiment } from '../../../../../../hooks/useDashboardReskinExperiment';

import { useFreePromotionNotification } from './hooks/useFreePromotionNotification';
import { FreePromotionNotification as FreePromotionNotificationReskin } from './index_new';

export function FreePromotionNotification() {
	const { data, actions } = useFreePromotionNotification();
	const {
		data: { isEnabled },
	} = useDashboardReskinExperiment();

	if (isEnabled) {
		return <FreePromotionNotificationReskin />;
	}

	return (
		<Flex
			data-qa="free-promotion-section-message"
			data-testid="free-promotion-section-message"
			p={24}
			sx={{ height: '100%', gap: 16 }}
		>
			<Icon icon={iconNotificationsNone} size={24} color="primary-white" />
			<Flex sx={{ flexDirection: 'column', alignItems: 'flex-start' }}>
				<Heading as="h2" size="h4">
					<Translate value="corgi.petition.starter_dashboard.notifications.free_promo.title" />
				</Heading>
				<Text mt={8}>
					<TranslatePlural
						value="corgi.petition.starter_dashboard.notifications.free_promo.body"
						replacements={{ impressions: data.impressions, amount: data.amountFormatted }}
						count={data.impressions}
					/>
				</Text>
				<Button
					data-testid="free-promotion-button"
					variant="secondary"
					size="small"
					loading={data.loading}
					onClick={actions.handleCreateFreePromotion}
					mt={16}
				>
					<Translate value="corgi.petition.starter_dashboard.notifications.free_promo.promote_button" />
				</Button>
			</Flex>
		</Flex>
	);
}
